export default function Switch({firstLabel, secondLabel, checked = false, classes = {}, onChange = () => {}}) {

    const {firstLabelClasses = "", secondLabelClasses = "", checkedClass = "", barClasses = "", parentClasses = ""} = classes

    return (
        <div className={parentClasses}>
            <p className={`font-semibold ml-5 ${firstLabelClasses}`}>{firstLabel}</p>
            <label className="switch relative inline-block w-[2.875rem] h-[1.438rem]">
                <input type="checkbox"
                       className="peer opacity-0 w-0 h-0"
                       onChange={onChange}
                       checked={checked}/>
                <span className={`rounded-xl ${checkedClass ? "peer-checked:"+checkedClass : ""} peer-focus:shadow-2xl absolute cursor-pointer inset-0 duration-300
                peer-checked:before:translate-x-[1.3rem] before:absolute before:rounded-full before:h-[1.063rem] before:w-[1.063rem] before:left-[0.3rem] before:bottom-[0.188rem] before:duration-300 ${barClasses}`} />
            </label>
            <p className={`font-semibold mr-6 ${secondLabelClasses}`}>{secondLabel}</p>
        </div>
    )
}
